import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ShieldCheck, ArrowRight, Info } from "lucide-react";
import { services, company } from "../mock";

export default function Footer() {
  return (
    <footer className="bg-navy text-slate-200 mt-24">
      <div className="container-x py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <img
              src={company.logoUrl}
              alt="Apex Quality Consultancy"
              className="h-12 md:h-14 w-auto object-contain"
              style={{ background: "transparent", boxShadow: "none", border: "none", filter: "brightness(0) invert(1)" }}
            />
            <p className="mt-6 text-[15px] text-slate-300 leading-[1.7]" data-testid="footer-tagline">
              {company.footerTagline}
            </p>

            <div className="mt-7 space-y-3 text-[14.5px]">
              <div className="flex items-start gap-3">
                <MapPin size={17} className="mt-0.5 text-teal-mid shrink-0" />
                <span className="text-slate-300">{company.address}. {company.serviceArea}.</span>
              </div>
              <div className="flex items-center gap-3">
                <Phone size={17} className="text-teal-mid" />
                <span className="text-slate-300" data-testid="footer-phones">
                  <a href={`tel:${company.phoneRaw}`} className="hover:text-white transition">{company.phone}</a>
                  <span className="text-slate-500 mx-2">|</span>
                  <a href={`tel:${company.phoneRaw2}`} className="hover:text-white transition">{company.phone2}</a>
                </span>
              </div>
              <div className="flex items-center gap-3">
                <Mail size={17} className="text-teal-mid" />
                <a href={`mailto:${company.email}`} className="text-slate-300 hover:text-white transition">{company.email}</a>
              </div>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-5">Services</h4>
            <ul className="space-y-3">
              {services.slice(0, 7).map((s) => (
                <li key={s.slug}>
                  <Link to={`/services/${s.slug}`} className="text-[14.5px] text-slate-300 hover:text-teal-light transition leading-[1.6]">
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-5">Company</h4>
            <ul className="space-y-3 text-[14.5px]">
              <li><Link to="/about" className="text-slate-300 hover:text-teal-light">About Us</Link></li>
              <li><Link to="/services" className="text-slate-300 hover:text-teal-light">Services</Link></li>
              <li><Link to="/pricing" className="text-slate-300 hover:text-teal-light">Pricing</Link></li>
              <li><Link to="/audit-readiness" className="text-slate-300 hover:text-teal-light">Audit Readiness</Link></li>
              <li><Link to="/quality-commitment" className="text-slate-300 hover:text-teal-light">Quality Commitment</Link></li>
              <li><Link to="/contact" className="text-slate-300 hover:text-teal-light">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-5">Book a discovery call</h4>
            <p className="text-[14.5px] text-slate-300 mb-5 leading-[1.65]">
              Free 15 minute call to discuss your registration pathway, documentation and audit readiness.
            </p>
            <Link to="/contact" className="btn-primary inline-flex items-center gap-2 px-5 py-3 rounded-lg text-sm font-semibold">
              Book Discovery Call <ArrowRight size={15} />
            </Link>
            <div className="mt-7 p-3.5 bg-white/5 rounded-lg border border-white/10 flex items-start gap-2.5">
              <ShieldCheck size={16} className="text-teal-mid shrink-0 mt-0.5" />
              <p className="text-[12.5px] text-slate-300 leading-[1.65]">
                Apex Quality Consultancy provides consultancy, internal audit and compliance preparation services. We do not act as the independent external Approved Quality Auditor for providers we have consulted to. We do not guarantee registration, audit approval, audit outcomes, participant referrals or client numbers.
              </p>
            </div>
            <div className="mt-3 p-3.5 bg-white/5 rounded-lg border border-white/10 flex items-start gap-2.5">
              <Info size={16} className="text-teal-mid shrink-0 mt-0.5" />
              <p className="text-[12.5px] text-slate-300 leading-[1.65]">
                Information provided by Apex Quality Consultancy is general consultancy and compliance preparation support only. It is not legal, financial, accounting or insurance advice. Providers should obtain independent professional advice where required.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-7 border-t border-white/10 flex flex-col md:flex-row gap-3 justify-between items-center text-xs text-slate-400">
          <p>© 2026 Apex Quality Consultancy Pty Ltd. All rights reserved.</p>
          <div className="flex gap-5">
            <Link to="/privacy-policy" className="hover:text-teal-light">Privacy Policy</Link>
            <Link to="/terms-of-service" className="hover:text-teal-light">Terms of Service</Link>
            <Link to="/compliance-disclaimer" className="hover:text-teal-light">Compliance Disclaimer</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
